import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { clearPrograms, loadPrograms } from 'redux/Programs/actions';
import { ssrHandler } from 'utils';

import ProgramsTemplate from './ProgramsTemplate';
import SidePanel from '../widgets/SidePanel';

import programs from '../../content/programs.json';

const isDone = {
  examples: null,
  'realized-programs': true,
  'current-programs': false
};

function parsePathname(pathname) {
  const [name, status] = pathname
    .split('/')
    .filter(Boolean)
    .slice(-2);

  return { name, status };
}

class Programs extends PureComponent {
  state = {
    open: false,
    selected: null
  };

  togglePanel = (cardId) => {
    this.setState({
      selected: cardId,
      open: !this.state.open
    });
  };

  render() {
    const data = this.props.programs.results
      .find(({ id }) => id === this.state.selected);

    return (
      <div className="programs-container">
        <ProgramsTemplate
          content={this.props.content}
          programs={this.props.programs}
          status={this.props.status}
          isMobile={this.props.isMobile}
          onCardClick={this.togglePanel}
        />

        <div ref={elem => { this.panel = elem; }}>
          <SidePanel
            open={this.state.open}
            content={data && data.content}
            onCloseClick={this.togglePanel}
          />
        </div>
      </div>
    );
  }
}

Programs.propTypes = {
  content: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string
  }),
  programs: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  status: PropTypes.oneOf([
    'examples',
    'realized-programs',
    'current-programs'
  ]),
  isMobile: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const { name, status } = parsePathname(props.location.pathname);

  return {
    status,
    content: programs.find(p => p.name === name),
    programs: state.programs,
    isMobile: state.app.width < 580
  };
};

function loadProgramsData(store, nextState, replace, callback) {
  const { name, status } = parsePathname(nextState.location.pathname);
  const actions = [loadPrograms(name, isDone[status])];

  ssrHandler(store.dispatch, actions, callback);
}

function clearProgramsData(store) {
  store.dispatch(clearPrograms());
}

const manage = [
  'securitization',
  'commercial-bonds',
  'collateral-bonds',
  'exchange-bonds',
  'investment-notes',
  'real-estate-fund',
  'private-equity-fund'

  // 'trading'
];

const support = [
  'investor-relations',
  'capital-transactions',
  'representative-for-bond-owners'
];

const createRoute = (store, section, pathname, program) => ({
  path: `/${section}/${pathname}/${program}/`,
  component: connect(mapStateToProps)(Programs),
  onEnter: loadProgramsData.bind(null, store),
  onLeave: clearProgramsData.bind(null, store)
});

export default store => [
  ...manage.map((path) => createRoute(store, 'manage', path, 'current-programs')),
  ...manage.map((path) => createRoute(store, 'manage', path, 'realized-programs')),
  ...support.map((path) => createRoute(store, 'support', path, 'examples'))
];




// WEBPACK FOOTER //
// ./src/components/Programs/index.js